// extracted by mini-css-extract-plugin
export default {"container":"DropdownMenu_container__frDfy"};